import { gql } from '@apollo/client';

export const GET_PRICE_MARGINS = gql`
  query GetPriceMargins {
    getPriceMargins {
      merchMargin
      streamMargin
      amaMargin
      tipMargin
      productMargin
    }
  }
`;

export const GET_STORE_PRICE_MARGINS = gql`
  query GetStorePriceMargins($storeId: ID!) {
    getStorePriceMargins(storeId: $storeId) {
      storeId
      merchMargin
      streamMargin
      amaMargin
      tipMargin
      productMargin
    }
  }
`;
